import React from 'react';

/**
 * ウォーターマーク/注釈のプレビュー位置スタイルを計算する
 * フルサイズオーバーレイ + flex で配置
 */
export const getPreviewPositionStyle = (position: string): React.CSSProperties => {
  const pos = position || 'center';

  let vKey = 'middle';
  let hKey = 'center';
  if (pos !== 'center') {
    const parts = pos.split('-');
    vKey = parts[0];
    hKey = parts[1];
  }

  const alignMap: Record<string, string> = {
    top: 'flex-start', middle: 'center', bottom: 'flex-end',
  };
  const justifyMap: Record<string, string> = {
    left: 'flex-start', center: 'center', right: 'flex-end',
  };

  return {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: alignMap[vKey] || 'center',
    justifyContent: justifyMap[hKey] || 'center',
    padding: '8px',
    pointerEvents: 'none' as const,
  };
};

/**
 * ウォーターマーク/注釈のフォントサイズを計算する
 */
export const calculateWatermarkFontSize = (text: string, scale: number): number => {
  const containerWidth = 346;
  const previewScale = containerWidth / 1920;
  const margin = 8;
  const maxTextWidth = containerWidth - (margin * 2);

  if (scale <= 0) return 0;
  const actualSizeRatio = (scale / 100) * 0.15;
  const calculatedFontSize = containerWidth * actualSizeRatio;
  const minFontSize = 12 * previewScale;
  const maxFontSize = containerWidth * 0.15;
  let fontSize = Math.max(minFontSize, Math.min(maxFontSize, calculatedFontSize));

  let charWidthRatio = 0.6;

  const japaneseChars = (text.match(/[\u3000-\u9fff\uff00-\uffef]/g) || []).length;
  const japaneseRatio = japaneseChars / text.length;

  if (japaneseRatio > 0.8) {
    charWidthRatio = 0.9;
  } else if (japaneseRatio > 0.2) {
    charWidthRatio = 0.7;
  } else if (/[mwMW]/.test(text)) {
    charWidthRatio = 0.85;
  }

  const estimatedTextWidth = text.length * fontSize * charWidthRatio;

  if (estimatedTextWidth > maxTextWidth) {
    const scaleFactor = maxTextWidth / estimatedTextWidth;
    fontSize = Math.max(minFontSize, fontSize * scaleFactor);
  }

  return fontSize;
};
